import { z } from 'zod';
import { DOCUMENT_ID_LENGTH } from '../../constants';
import { requiredFieldError, requiredString } from '../../helper';
import { ApplicationDocumentType } from '../../types';

export const document = z.array(
  z.object({
    documentId: requiredString(),
    fileName: requiredString(),
  }),
  { errorMap: () => ({ message: requiredFieldError() }) },
);

export const applicationDocument = z.object({
  id: z.string().length(DOCUMENT_ID_LENGTH, `Document ID must be ${DOCUMENT_ID_LENGTH} characters long`),
  type: z.nativeEnum(ApplicationDocumentType),
});
